import Card from "@mui/material/Card";

// Argon Dashboard 2 MUI components
import ArgonBox from "components/ArgonBox";
import ArgonTypography from "components/ArgonTypography";
// Argon Dashboard 2 MUI examples
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import Table from "examples/Tables/Table";
import Grid from "@mui/material/Grid";
import ArrowCircleDownIcon from "@mui/icons-material/ArrowCircleDown";
// Data
import tutorTableData from "Views/people/tutor/data/tutorTableData";
import CurriculumTableData from "Views/Curriculum/data/curriculumTableData";
import { useState, useEffect } from "react";
import ArgonInput from "components/ArgonInput";
import ApnaTabs from "components/ApnaTabs/ApnaTabs";
import DeleteDialog from "components/DeleteDialog/DeleteDialog";
import { height, width } from "@mui/system";
import Class from "Views/Curriculum/Class/index";
import Board from "Views/Curriculum/Board";
import Subject from "Views/Curriculum/Subject";
import TimeSlot from "Views/Curriculum/timeSlot";
import Category from "Views/Curriculum/Category";
import Qualification from "Views/Curriculum/Qualification";
import SubjectTableData from "Views/Curriculum/data/subjectTableData";
import BoardTableData from "Views/Curriculum/data/boardTableData";
import TimeSlotTableData from "Views/Curriculum/data/timeSlotTableData";
import CategoryTableData from "Views/Curriculum/data/categoryTableData";
import QualificationTableData from "Views/Curriculum/data/qualificationTableData";
import { hasAnyPermission } from "utils/permissionConstants";

function Tables() {
  const [permissions, setPermissions] = useState({});
  const [refresh, setRefresh] = useState(false); // trigger table refresh
  //popup
  const [deleteDialog, setDeleteDialog] = useState(false);
  // Delete button click handler
  const handleDeleteClick = () => {
    setDeleteDialog(true);
  };

  // Close dialog
  const handleCloseDialog = () => {
    setDeleteDialog(false);
  };

  // Load permissions from localStorage
  useEffect(() => {
    const allowedPermissions = JSON.parse(localStorage.getItem("allowedPermissions")) || {};
    console.log("Curriculum permissions loaded:", allowedPermissions);
    console.log("Permissions type:", Array.isArray(allowedPermissions) ? "array" : "object");
    console.log("Has class permission:", hasAnyPermission(allowedPermissions, "class"));
    console.log("Has board permission:", hasAnyPermission(allowedPermissions, "board"));
    console.log("Has subject permission:", hasAnyPermission(allowedPermissions, "subject"));
    console.log("Has slots permission:", hasAnyPermission(allowedPermissions, "slots"));
    setPermissions(allowedPermissions);
  }, []);

  // Helper function to check permissions
  const checkPermission = (moduleKey) => {
    // Super admin check
    if (Array.isArray(permissions) && permissions.includes("ALL")) {
      return true;
    }

    // Object-based permissions check
    if (permissions && typeof permissions === "object" && !Array.isArray(permissions)) {
      const module = permissions[moduleKey];
      if (!module) return false;
      return module.create || module.get || module.update || module.delete;
    }

    return false;
  };

  console.log("Current permissions in Curriculum:", permissions);

  const { count: subjectCount } = SubjectTableData(() => {}, refresh);
  const { count: boardCount } = BoardTableData(() => {}, refresh);
  const { count: classCount } = CurriculumTableData(() => {}, refresh);
  const { count: timeSlotCount } = TimeSlotTableData(() => {}, refresh);
  const { count: categoryCount } = CategoryTableData(() => {}, refresh);
  const { count: qualificationCount } = QualificationTableData(() => {}, refresh);

  const tabsData = [];

  // Only show tabs if user has permissions for the respective modules

  if (checkPermission("category")) {
    tabsData.push({ label: "Category", count: categoryCount, content: <Category /> });
  }
  if (checkPermission("qualification")) {
    tabsData.push({
      label: "Qualification",
      count: qualificationCount,
      content: <Qualification />,
    });
  }
  if (checkPermission("class")) {
    tabsData.push({ label: "Class", count: classCount, content: <Class /> });
  }
  if (checkPermission("board")) {
    tabsData.push({ label: "Board", count: boardCount, content: <Board /> });
  }
  if (checkPermission("subject")) {
    tabsData.push({ label: "Subject", count: subjectCount, content: <Subject /> });
  }
  if (checkPermission("slots")) {
    tabsData.push({ label: "Time Slot", count: timeSlotCount, content: <TimeSlot /> });
  }

  console.log("Tabs data:", tabsData);

  // If no tabs are available, show a message
  if (tabsData.length === 0) {
    return (
      <DashboardLayout>
        <DashboardNavbar />
        <ArgonBox py={3}>
          <ArgonBox mb={3}>
            <Card>
              <ArgonBox p={3} textAlign="center">
                <ArgonTypography variant="h6" color="text">
                  You don&apos;t have permission to access any curriculum modules.
                </ArgonTypography>
                <ArgonTypography variant="body2" color="text" mt={1}>
                  Please contact your administrator to grant appropriate permissions.
                </ArgonTypography>
              </ArgonBox>
            </Card>
          </ArgonBox>
        </ArgonBox>
        <Footer />
      </DashboardLayout>
    );
  }

  return (
    <DashboardLayout>
      <DashboardNavbar />

      <ArgonBox py={3}>
        <ArgonBox mb={3}>
          <Card>
            <ArgonBox p={3}>
              <ArgonTypography mb={2} variant="h6">
                All Curriculum
              </ArgonTypography>
              <ArgonBox>
                <ApnaTabs tabsData={tabsData} />
              </ArgonBox>
            </ArgonBox>
          </Card>
        </ArgonBox>
      </ArgonBox>
      <Footer />
    </DashboardLayout>
  );
}

export default Tables;
